<template>
  <div class="user-status-filter-item status">
    <label
      class="item-label"
      v-t.preserve="'appUserStatusFilterStatus.status'"
    />
    <b-form-select size="sm" v-model="value" v-bind:options="options" />
  </div>
</template>

<script>
import { RestApiClient } from 'ifield-core-components'
import { useHandleApiError } from '@/composables/UseHandleApiError'

export default {
  name: 'AppUserStatusFilterStatus',
  props: {
    /**
     * 選択値
     */
    statusTypeId: {
      type: Number,
      default: null,
    },
  },
  setup() {
    const { handleApiError } = useHandleApiError()
    return { handleApiError }
  },
  data: function () {
    return {
      // ローカル値
      value: this.statusTypeId,
      // ステイタス種別データ
      statusTypes: [],
    }
  },
  computed: {
    /**
     * セレクターの選択肢
     * @type {Array.<Object>}
     */
    options: function () {
      const options = this.statusTypes.map((v) => ({
        value: v.id,
        text: v.status_type_name,
      }))
      options.unshift({
        value: null,
        text: this.$t('appUserStatusFilterStatus.allStatuses'),
      })
      return options
    },
    /**
     * イベント返却用の値
     * @type {Object}
     */
    resultValue: function () {
      return { statusTypeId: this.value }
    },
    /**
     * イベント返却用のテキスト
     * @type {String}
     */
    resultText: function () {
      return this.value == null
        ? ''
        : this.options.find((b) => b.value === this.value)?.text || ''
    },
  },
  watch: {
    statusTypeId: function (value) {
      this.value = value
    },
    value: function () {
      this.$_onChange()
    },
  },
  created: function () {
    this.$_getStatusTypes()
  },
  mounted: function () {
    // 初回結果表示のためにpropsの値で変更されたことにする
    if (this.statusTypes.length) {
      this.$_onChange()
    } else {
      // 取得できるのを待つ(1回だけwatch)
      const unwatch = this.$watch('statusTypes', () => {
        this.$_onChange()
        unwatch()
      })
    }
  },
  methods: {
    /**
     * ステイタス種別データを取得する
     */
    $_getStatusTypes: async function () {
      const url = RestApiClient.createApiUrl('status_type')
      try {
        const json = await RestApiClient.executeGetApi(url)
        this.statusTypes = json.data
      } catch (error) {
        this.handleApiError(error)
      }
    },
    /**
     * 変更時処理
     */
    $_onChange: function () {
      /**
       * 選択値変更イベント
       * @param {Object} value 選択値
       * @param {String} text 選択値表示テキスト
       */
      this.$emit('changed', { value: this.resultValue, text: this.resultText })
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/user/user-status-filter-item';
</style>
